import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setRole } from "../redux/slices/role";
import { rl } from "../constants";
import { API_BASE_URL } from "../config";
import { setRooms } from "../redux/slices/websocket";
import { resetNotifications } from "../redux/slices/notifications";

const useAuth = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const signIn = async (username, password) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    };
    const response = await fetch(
      `${API_BASE_URL}/api/authentication`,
      requestOptions,
    );
    const responseData = await response.json();

    if (responseData.status === 1) {
      // Login successful
      sessionStorage.setItem("token", responseData.data.token);
      sessionStorage.setItem("nome", responseData.data.nome);
      sessionStorage.setItem("cognome", responseData.data.cognome);
      sessionStorage.setItem("agenzia", responseData.data.agenzia);
      sessionStorage.setItem("nomeAvatar", responseData.data.nomeAvatar);
      sessionStorage.setItem("roomsName", responseData.data.roomsName);
      sessionStorage.setItem("email", responseData.data.email);
      sessionStorage.setItem("uid", responseData.data.uid);
      dispatch(setRooms(responseData.data.roomsName));
      dispatch({ type: "websocket/connect", payload: API_BASE_URL });
      // Fetch notifications once after login for navbar
      const { fetchNotifications } = require("../redux/slices/notifications");
      dispatch(fetchNotifications());

      return true;
    } else {
      // Login failed
      return false;
    }
  };

  const signOut = async () => {
    const token = sessionStorage.getItem("token");

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + token,
      },
      body: JSON.stringify({ token }),
    };
    await fetch(`${API_BASE_URL}/api/logout`, requestOptions);
    dispatch({ type: "websocket/disconnect" });
    dispatch(resetNotifications());
    sessionStorage.clear();
    navigate("/auth/sign-in");
  };

  async function getData(data) {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({ token, data: data }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/getData`,
        requestOptions,
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      switch (data.action) {
        case "menu":
          return responseData;
        case "usersList":
        case "toponimi":
        case "provincie":
        case "comuni":
        case "cap":
        case "nazioni":
        case "tipologiacontatti":
        case "rcAutoGetFilter":
        case "rcAutoGetFilterValue":
        case "getPreviewInfo":
          return responseData;
        default:
          return undefined;
      }
    } catch (error) {
      return error;
    }
  }

  async function setData(action, data) {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({ token, action, data }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/setData`,
        requestOptions,
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  }

  async function getUserInfo(iduser) {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
      };

      const query = new URLSearchParams();

      if (iduser) query.append("iduser", iduser);

      const response = await fetch(
        `${API_BASE_URL}/api/user${
          query.toString() ? `?${query.toString()}` : ""
        }`,
        requestOptions,
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  }

  /* const getRCAutoDetails = async (idTarga) => {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json",authorization : "Bearer " + token },
        body: JSON.stringify({
          token,
          data: {
            idUIDTarga: idTarga,
          },
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/rcAutoGetDetails`,
        requestOptions
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  }; */

  const getRCAutoDetails = async (idTarga) => {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          token,
          data: {
            idUIDTarga: idTarga,
          },
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/rcAutoGetDetails`,
        requestOptions,
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  };

  async function sendAnagraficaData(idUser, data) {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({ token, idUser, data }),
      };

      const response = await fetch(`${API_BASE_URL}/api/user`, requestOptions);
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  }

  async function getRcData(
    rowsPages,
    pageNumbers,
    idUidFlotta,
    filterData,
    idTipologia,
  ) {
    const token = sessionStorage.getItem("token");

    try {
      const queryParams = new URLSearchParams();
      if (filterData?.targa) queryParams.append("targa", filterData?.targa);
      if (filterData?.cliente)
        queryParams.append("cliente", filterData?.cliente);
      if (filterData?.aziende)
        queryParams.append("aziende", filterData?.aziende);
      if (filterData?.agenti) queryParams.append("agenti", filterData?.agenti);
      if (filterData?.stato) queryParams.append("stato", filterData?.stato);
      if (filterData?.aging) queryParams.append("aging", filterData?.aging);
      if (idUidFlotta) queryParams.append("idUidFlotta", idUidFlotta);
      if (idTipologia) queryParams.append("idTipologia", idTipologia);

      const qs = queryParams.toString();
      console.log(queryParams);

      const endpoint = `${API_BASE_URL}/api/rcAuto/list/${rowsPages}/${pageNumbers}${
        qs ? `?${qs}` : ""
      }`;

      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
      };
      const response = await fetch(endpoint, requestOptions);

      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  }

  async function rcAutoNewUpdate(data, action) {
    const token = sessionStorage.getItem("token");
    console.log(data);
    let method;
    let endpoint = `${API_BASE_URL}/api/rcAuto`;

    if (!data?.idUID) {
      method = "POST";
      endpoint = `${API_BASE_URL}/api/rcAuto`;
    } else {
      switch (action) {
        case "reboot":
          method = "POST";
          endpoint = `${API_BASE_URL}/api/rcAuto/${data.idUID}/reboot`;
          break;
        case "updateDataForm":
          method = "PATCH";
          endpoint = `${API_BASE_URL}/api/rcAuto/${data.idUID}`;
          break;
      }
    }

    try {
      const requestOptions = {
        method: method,
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({ data }),
      };
      const response = await fetch(endpoint, requestOptions);
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  }

  const getFleetData = async (
    rowsPages,
    pageNumbers,
    nomeFlotta = "",
    idTipologia = 1,
  ) => {
    const token = sessionStorage.getItem("token");

    let qs = "";
    if (nomeFlotta) qs += `/${nomeFlotta}`;
    if (idTipologia) qs += `/${idTipologia}`;

    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
      };

      const response = await fetch(
        `${API_BASE_URL}/api/flotte/${rowsPages}/${pageNumbers}${
          qs ? `?${qs}` : ""
        }`,
        requestOptions,
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  };

  const flotteNewUpdate = async (nomeFlotta, numeroTarghe, data) => {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({ nomeFlotta, numeroTarghe, data }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/flotte`,
        requestOptions,
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  };

  const flotteDownload = async (idUidFlotta) => {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
      };

      const response = await fetch(
        `${API_BASE_URL}/api/flotte/documents/${idUidFlotta}/download`,
        requestOptions,
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  };

  const flussiGetList = async (rowsPages, pageNumbers) => {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          token,
          rowsPages,
          pageNumbers,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/flussiGetList`,
        requestOptions,
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  };

  const flussiGetDetails = async (flusso, stato) => {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          flusso,
          stato,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/flussiGetDetails`,
        requestOptions,
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }

      return responseData;
    } catch (error) {
      return error;
    }
  };

  return {
    signIn,
    signOut,
    getData,
    getUserInfo,
    setData,
    sendAnagraficaData,
    getRcData,
    getRCAutoDetails,
    rcAutoNewUpdate,
    getFleetData,
    flotteNewUpdate,
    flotteDownload,
    flussiGetList,
    flussiGetDetails,
  };
};

export default useAuth;
